import React, { useContext, useState } from 'react'
import { useEffect } from 'react'
import { Button } from 'primereact/button'

import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import ModalDieSession from '../../../Base/Components/Panel/ModalDieSession'

import HeadCountScreen from '../../RRHH/HeadCount/HeadCountScreen'

import './KPIGerencia.scss'
import ResumenVentasAnual from '../../Ventas/ResumenVentas/ResumenVentasAnual'
import ResumenVentasTotales from '../../Ventas/ResumenVentas/ResumenVentasTotales'
import ResumenVentasDialog from '../../Ventas/ResumenVentas/ResumenVentasDialog'

import MetasSemanalesTintoreria from '../../Ventas/ResumenVentas/MetasSemanalesTintoreria'
import MetasSemanalesPorCategoria from '../../Ventas/ResumenVentas/MetasSemanalesPorCategoria'

import PersonalPorArea from '../../RRHH/HeadCount/PersonalPorArea'

import { useNavigate } from 'react-router-dom'
import { Dialog } from 'primereact/dialog'
import { baseLang } from '../../../Base/Lang/BaseLang'
import { getLabel } from '../../../Base/Services/Language/LanguageService'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext'


function KPIsGerenciaScreen() {

    const [fecha, setFecha] = useState(new Date());
    const [getInfo, setGetInfo] = useState(false);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showModalMensuales, setShowModalMensuales] = useState(false);
    const [showMetasProduccion, setShowMetasProduccion] = useState(false);
    const [showPersonal, setShowPersonal] = useState(false);
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
      });

    let Mes = fecha.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);
    const { config } = useContext(ConfigContext);

    const buscar = () => {
        setGetInfo(true);
        setTimeout(() => {
            setGetInfo(false);
        }, 1000);
    }



    // console.log(screenSize)
    useEffect(() => {
        buscar()
    }, [fecha])

    useEffect(() => {
        window.document.title = 'PPF • Dashboard PPF'
    }, [])


    useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
      
        window.addEventListener('resize', handleResize);
        
        // Cleanup function to remove the event listener on component unmount
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
      

    return (
        <div className='p-1' style={{ height: '100vh', overflowY: 'scroll' }}>

            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex mt-2' style={{ marginLeft: '50px' }}>
                    <Button
                        tooltip='Home'
                        icon='pi pi-arrow-left'
                        onClick={() => {
                            navigate(`${process.env.REACT_APP_ENV}/Home`);
                        }}
                    />
                </div>
                <div className='mx-4 mt-2'>
                    <CalendarWeek date={fecha} setDate={e => setFecha(e)} buscar={buscar} view="month" dateFormat="mm/yy" />
                </div>

                <h2 style={{ margin: '0 auto' }}>Dashboard PPF</h2>

                <div className='d-flex align-items-center' style={{ marginLeft: 'auto' }}>
                    <Button
                        icon='pi pi-times'
                        className="p-button-text"
                        onClick={() => {
                            navigate(`${process.env.REACT_APP_ENV}/Home`);
                        }}
                    />
                </div>
            </div>

            <div className='kpsGerencia'>


                <div className='headCount' style={{ width: '100%', overflow: 'hidden' }}>
                    <HeadCountScreen kpiGerencia={true} fecha={fecha} buscar={getInfo} setShowPersonal={setShowPersonal}/>
                </div>

                <div className='salesAnual' style={{ width: '98%', overflow: 'hidden' }}>
                    <ResumenVentasAnual kpiGerencia={true} date={fecha} getDatos={getInfo} setShowModal={setShowModal} />
                </div>

                <div className='salesTotales' style={{ width: '100%', overflow: 'hidden' }}>
                    <ResumenVentasTotales kpiGerencia={true} date={fecha} getDatos={getInfo} setShowModalMensuales={setShowModalMensuales}/>
                </div>

                <div className='salesSemanal' style={{ width: '98%', overflow: 'hidden' }}>
                    <MetasSemanalesTintoreria kpiGerencia={true} date={fecha} getDatos={getInfo} setShowMetasProduccion={setShowMetasProduccion} />
                </div> 

            </div>



            <Dialog
                visible={showModal}
                onHide={() => {setShowModal(false)}}
                maximized={false}
                closeOnEscape={false}
                style={{ width: '70vw'}}
                resizable={false}
            >
                <div className='salesAnual' style={ {width: '100%', overflow: 'hidden', height: '100%'}}>
                    <ResumenVentasAnual kpiGerencia={false} date={fecha} getDatos={getInfo} altura={true} />
                </div>
            </Dialog>

            
            <Dialog
                visible={showModalMensuales}
                onHide={() => {setShowModalMensuales(false)}}
                maximized={true}
                closeOnEscape={false}
                style={{ width: '80vw'}}
                resizable={false}
                // header={<h4>{`Ventas mensuales(${monthName} / ${fecha.getFullYear()}) ($)`}</h4>}
                header={<h4>{`${getLabel(baseLang, "ventasMesuales", config.language)} / ${fecha.getFullYear()} ($)`}</h4>}
            >
                {/* <div className='salesSemanal' style={ {width: '100%', overflow: 'hidden', height: '50%'}}> */}
                    {/* <ResumenVentasMensual kpiGerencia={true} date={fecha} getDatos={getInfo} altura={true} /> */}
                    <ResumenVentasDialog kpiGerencia={true} date={fecha} getDatos={getInfo} altura={true} />
                {/* </div> */}
            </Dialog>

            <Dialog
                visible={showMetasProduccion}
                onHide={() => {setShowMetasProduccion(false)}}
                // header={<h4>{`Producción Mensual (${monthName} / ${fecha.getFullYear()}) (Kg)`}</h4>}
                header={<h4>{`${getLabel(baseLang, "pMensual", config.language)} (${monthName} / ${fecha.getFullYear()}) (Kg)`}</h4>}
                maximized={false}
                closeOnEscape={false}
                style={{ width: '80vw'}}
                resizable={false}
            >
                {/* <div style={ {width: '100%', overflow: 'hidden', height: '50%'}}> */}
                    <MetasSemanalesPorCategoria kpiGerencia={false} date={fecha} getDatos={getInfo} altura={true} />
                {/* </div> */}
            </Dialog>


            <Dialog
                visible={showPersonal}
                onHide={() => {setShowPersonal(false)}}
                maximized={false}
                closeOnEscape={false}
                style={{ width: '80vw'}}
                resizable={false}
            >
                <div className='personalArea' style={{width: '100%', overflow: 'hidden', height: '50%'}}>
                    <PersonalPorArea fecha={fecha} kpiGerencia={false} getDatos={getInfo} />
                </div>
            </Dialog>
            
            

            <ModalDieSession />

        </div>
    )
}

export default KPIsGerenciaScreen